import {Component, AfterViewInit, OnInit} from '@angular/core';
import {ChangePasswordForm} from '../../../models';
import {AuthService, ScrollService, MessagesServices} from '../../api/';
import {ToastyService, ToastyConfig, ToastOptions} from 'ng2-toasty';
import {MdDialogRef} from '@angular/material';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements AfterViewInit, OnInit {
    private model: ChangePasswordForm;
    private errorArray: Array<any>;
    private loading: boolean = false;
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    public onlineOffline1: boolean = navigator.onLine;

    constructor(private authService: AuthService, private sm: MessagesServices, private toastyService: ToastyService, private toastyConfig: ToastyConfig,
    public dialogRef: MdDialogRef<ChangePasswordComponent>, private scrollService: ScrollService) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});
        this.model = new ChangePasswordForm();
        this.errorArray = new Array<any>();
        //getting messages from db
        this.messages = this.sm.messags;
        this.setMessages();
    }

    ngOnInit(){
        this.scrollService.enableScrollIfDisabled();
    }

    /**
     * setting system messages
     **/
    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_PASSWORD_CHANGE_SUCCESSFULLY') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
            }
        }
    }

    ngAfterViewInit() {
        this.scrollService.toggleProgressBar(false);
    }

    changePassword() {
        this.scrollService.toggleProgressBar(true);
        this.loading = true;
        if(this.onlineOffline1){
        this.authService.changePassword(this.model).subscribe((res) => {
            this.dialogRef.close(false);
            let toastOptions: ToastOptions = {
                title: this.title1,
                msg: this.msg1,
                showClose: true,
                timeout: 2000,
                theme: 'default'
            };
            this.scrollService.toggleProgressBar(false);
            this.loading = false;
            this.toastyService.success(toastOptions);
        }, (err) => {
            this.loading = false;
            this.scrollService.toggleProgressBar(false);
            this.handleErrors(err);
        });
        } else{
            this.loading = false;
            this.scrollService.toggleProgressBar(false);
        }
    }

    handleErrors(err: any) {
        this.errorArray = [];
        let validationErrors = JSON.parse(err._body);
        if (err._body) {
            for (let index = 0; index < validationErrors.length; index++) {
                this.errorArray[validationErrors[index].field] = validationErrors[index].message;
            }
        }
    }
    
}



// WEBPACK FOOTER //
// ./src/app/user/change-password/change-password.component.ts